import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

function BackButton({ history }) {
  const goBack = () => history.goBack();
  return (
    <button className="btn btn-back" onClick={goBack}>
      <i className="fa fa-arrow-left" />
    </button>
  );
}

BackButton.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(BackButton);
